import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { SERVICES } from "../data/services";
import { EASE } from "../components/site/Reveal";
import { ClosingCta } from "../components/home/ClosingCta";

const Row = ({ s, i }) => (
  <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease: EASE, delay: 0.05 * i }}>
    <Link to={`/services/${s.slug}`} data-testid={`service-row-${s.slug}`}
      className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center border-t border-[#0A192F]/15 py-10 sm:py-12">
      <span className="md:col-span-1 font-mono text-xs tracking-[0.25em] text-[#8A6A2B]">{s.no}</span>
      <div className="md:col-span-3 relative h-52 md:h-36 overflow-hidden rounded-2xl">
        <img src={s.image} alt={s.title} className="absolute inset-0 h-full w-full object-cover grayscale-[40%] transition-[transform,filter] duration-[1.2s] group-hover:scale-110 group-hover:grayscale-0" />
      </div>
      <div className="md:col-span-7">
        <h2 className="font-display text-4xl sm:text-5xl text-[#0A192F] leading-tight transition-transform duration-500 group-hover:translate-x-3">{s.title}</h2>
        <p className="mt-3 text-[#4A5468] text-base sm:text-lg max-w-2xl">{s.short}</p>
      </div>
      <span className="md:col-span-1 justify-self-start md:justify-self-end grid h-14 w-14 place-items-center rounded-full border border-[#0A192F]/20 text-[#0A192F] transition-[background-color,color,transform] duration-500 group-hover:bg-[#0A192F] group-hover:text-[#E3C88A] group-hover:rotate-45">
        <ArrowUpRight className="h-5 w-5" />
      </span>
    </Link>
  </motion.div>
);

export default function Services() {
  return (
    <>
      <PageHero testid="services-hero" eyebrow="Services" lines={["Counsel for", <span className="italic text-[#E3C88A]">every square foot.</span>]}
        intro="A single window for all legal, verification, and financial needs related to real estate — from the first title check to the final loan disbursal." />
      <section className="paper py-16 sm:py-24" data-testid="services-list">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
          {SERVICES.map((s, i) => <Row key={s.slug} s={s} i={i} />)}
        </div>
      </section>
      <ClosingCta />
    </>
  );
}
